import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API while preserving both
 * component state and the generated section stylesheet returned by Shopify.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') return;

  try {
    await sectionRenderer.renderSection(normalizedId, {
      cache: false,
      url,
      mode: 'hydration',
      injectStylesheet: true,
    });
    section.dataset.hydrated = 'true';
  } catch (error) {
    console.warn(`By Alice: section hydration skipped for ${normalizedId}`, error);
  }
}

/**
 * Hydrates a section when the DOM is ready.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
